<section class="sticky-wrapper">
    <dx-toolbar [visible]="visible" class="dx-swatch-additional toolbar-container">
        <dxi-item *ngFor="let item of actionItems" locateInMenu="auto" [location]="item.location" [widget]="item.widget"
            [options]="item.options"></dxi-item>
        <dxi-item *ngFor="let item of exportItems" [location]="item.location" [widget]="item.widget"
            [options]="item.options" [visible]="showExportItems"></dxi-item>
        <dxi-item location="before" widget="dxButton"
            [options]="historyActionItem" [visible]="showHistoryItem"></dxi-item>
    </dx-toolbar>
</section>